import { z } from 'zod';

export const LordCoinsHistoryItemSchema = z.object({
  date: z.string(),
  coinsEarned: z.number().int().nonnegative(),
  streakDay: z.number().int().min(1).max(7),
});

export type LordCoinsHistoryItem = z.infer<typeof LordCoinsHistoryItemSchema>;

export const LordCoinsBalanceResponseSchema = z.object({
  balance: z.number().int().nonnegative(),
  recentHistory: z.array(LordCoinsHistoryItemSchema),
});

export type LordCoinsBalanceResponse = z.infer<typeof LordCoinsBalanceResponseSchema>;
